import React from 'react';

export default function useAsyncEffect(effect: () => Promise<any>, deps: Array<any>) {
  React.useEffect(() => {
    let isActive = true;
    if (isActive) effect();
    return () => { isActive = false; };
  }, deps);
}
